import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';
import { FileModel } from '../../../@models';

const MAX_INSTANCES = 60;

@Component({
  template: `
    <input *ngIf="cell.getColumn().id != 'color' && cell.getColumn().id != 'coreImage'" [ngClass]="inputClass"
            #text
           class="form-control"
           style="padding: 0.375rem 0.75rem"
           [(ngModel)]="cell.newValue"
           [name]="cell.getId()"
           [placeholder]="cell.getTitle()"
           [disabled]="!cell.isEditable()"
           (click)="onClick.emit($event)"
           (keyup)="updateValue()"
           (keydown.enter)="onEdited.emit($event)"
           (keydown.esc)="onStopEditing.emit()">

    <select *ngIf="cell.getColumn().id == 'color'" [ngClass]="inputClass"
            #select
            class="form-control"
            [(ngModel)]="cell.newValue"
            [name]="cell.getId()"
            [disabled]="!cell.isEditable()"
            (click)="onClick.emit($event)"
            (change)="syncValues()"
            (keydown.enter)="onEdited.emit($event)"
            (keydown.esc)="onStopEditing.emit()">
        <option *ngFor="let option of cell.getColumn().getConfig()?.list" [value]="option.value"
                [selected]="option.value === cell.getValue()">{{ option.title }}
        </option>
    </select>
    <ngx-form-upload *ngIf="cell.getColumn().id == 'coreImage'" [fullwidth]="true" accept="image/jpeg" url="/api/v1/upload" [(files)]="cell.newValue" (filesChange)="filesChange($event)"></ngx-form-upload>
  `,
})
export class CoreEditorComponent extends DefaultEditor implements AfterViewInit {

  @ViewChild('text') text: ElementRef;
  @ViewChild('select') select: ElementRef;

  static instances = [];
  static count = 0;

  files: FileModel[];

  constructor() {
    super();
  }

  ngAfterViewInit() {
    CoreEditorComponent.instances.push(this);
    if (CoreEditorComponent.instances.length > MAX_INSTANCES) {
      CoreEditorComponent.instances.splice(0, 1);
    }
  }

  filesChange(files: FileModel[]) {
    // console.log(files);
    this.cell.newValue = files;
  }

  updateValue() {
    // console.log('update value', this.text.nativeElement.value);
    this.cell.newValue = this.text.nativeElement.value;
    this.syncValues();
  }

  count = 0;
  syncValues() {
    for (let i = 0; i < CoreEditorComponent.instances.length; i++) {
      const inst = CoreEditorComponent.instances;
      const val = this.cell.newValue;
      const re = /(\w)\-([\d.,]+)?\-?([\d.,]+)?\-?([RGTC]+)?.*/;
      if (inst[i] === this) {
        switch (this.cell.getColumn().id) {
          case 'name':
            if (val.match(re)) {
              const diam = val.match(re)[2];
              const width = val.match(re)[3];
              const color = val.match(re)[4];
              inst[i + 1].text.nativeElement.value = diam ? diam : null;
              inst[i + 1].cell.newValue = diam ? diam : null;
              inst[i + 2].text.nativeElement.value = width ? width : null;
              inst[i + 2].cell.newValue = width ? width : null;
              inst[i + 3].cell.newValue = color ? color : null;
            }
            break;
          case 'innerDiameter':
            if (val.match(/[\d.,]+/)) {
              let name = inst[i-1].text.nativeElement.value;
              if (!name.match(/-/g)) {
                name += '-' + val;
              } else {
                name = name.replace(re, '$1-' + val + '-$3-$4');
              }
              inst[i-1].text.nativeElement.value = name;
              inst[i-1].cell.newValue = name;
            }
            break;
          case 'width':
            if (val.match(/[\d.,]+/)) {
              let name = inst[i-2].text.nativeElement.value;
              name = name.replace(re, '$1-$2-' + val + '-$4');
              inst[i-2].text.nativeElement.value = name;
              inst[i-2].cell.newValue = name;
            }
            break;
          case 'color':
            if (val.match(/[\w]+/)) {
              let name = inst[i-3].text.nativeElement.value;
              name = name.replace(re, '$1-$2-$3-' + val);
              inst[i-3].text.nativeElement.value = name;
              inst[i-3].cell.newValue = name;
            }
            break;
        }
      }
    }
  }
}
